<script>
import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../../helpers/validators_files";
import DatePicker from "vue2-datepicker"; // add DatePicker
import { swal } from "../../../helpers/handle_error.js";
import accommodation_plots from '../../../helpers/list/accommodation_plots';
import city from '../../../helpers/list/city';

export default {
  components: { DatePicker },
  props: {},
  data() {
    return {
      fields: [],
      not_receiving: false,

      //list
      list_accommodation: accommodation_plots,
      list_city: city,
    };
  },
  validations: {
    fields: {
      $each: {
        grant_name: { required, minLength: minLength(2), maxLength: maxLength(50) },
        section_number: { required, minLength: minLength(2), maxLength: maxLength(15) },

        received_date: { required },
        ammont: { required, minValue: minValue(1000), maxValue: maxValue(80000000) },

        accommodation_id: { required },
        area_section: { required, minValue: minValue(1), maxValue: maxValue(1000) },

        city_id: { required },
        district: { required, minLength: minLength(2), maxLength: maxLength(50) },
        sub_district: { required, minLength: minLength(2), maxLength: maxLength(50) },

        attachment_grant: {
          required,
          fileType: fileType("application/pdf"),
          fileSize: fileSize(1024 * 1024 * 2),
        },
      },
    },
    form: ["fields"],
  },
  methods: {
    //  Push the row in form
    AddformDataS() {
      this.fields.push({
        grant_name: "",
        section_number: "",
        received_date: "",
        ammont: "",
        accommodation_id: "",
        area_section: "",
        city_id: "",
        district: "",
        sub_district: "",
        attachment_grant: "",
      });
    },
    // Delete the row
    async deleteRowS(index) {
      if (await swal.confirm()) {
        this.fields.splice(index, 1);
      }
    },
    notReceiving(index) {
      this.fields.splice(index, 1);
      return this.not_receiving ? this.AddformDataS() : this.fields.splice(index, 1);
    },
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
    chnageFile(e) {
      e = e.target;
      let index = e.getAttribute("data-index");
      this.fields[index][e.id] = e.files.length > 0 ? e.files[0] : null;
    },
  },
  created() {
    this.AddformDataS();
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات منح البناء</h5></div>

      <div class="col-md-12">
        <div class="form-check form-switch mb-3 ms-2 form-switch-md">
          <input
            @click="notReceiving(index)"
            class="form-check-input"
            type="checkbox"
            id="SwitchCheckSizemd"
            v-model="not_receiving"
          />
          <label class="form-check-label" for="SwitchCheckSizemd"
            >لم استلم اي منحة بناء .</label
          >
        </div>
      </div>

      <form class="repeater" enctype="multipart/form-data">
        <div v-for="(field, index) in $v.fields.$each.$iter" :key="field.id" class="">
          <div class="row">
            <b-form-group
              class="col-md-6 mb-3"
              label="الجهة المانحة : "
              label-for="grant_name"
            >
              <b-form-input
                id="grant_name"
                type="text"
                placeholder="ادخل الجهة المانحة"
                v-model.trim="field.grant_name.$model"
                :class="{ 'is-invalid': field.grant_name.$error }"
              ></b-form-input>
              <div v-if="field.grant_name.$error" class="invalid-feedback">
                <span v-if="!field.grant_name.required">هذا الحقل الزامي</span>
                <span v-if="!field.grant_name.minLength"
                  >يجب أن تكون الجهة المانحة من حرفين على الأقل</span
                >
                <span v-if="!field.grant_name.maxLength"
                  >يجب أن تكون الجهة المانحة من 50 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-6 mb-3"
              label="رقم القطعة : "
              label-for="section_number"
            >
              <b-form-input
                id="section_number"
                type="text"
                placeholder="ادخل رقم القطعة"
                v-model.trim="field.section_number.$model"
                :class="{ 'is-invalid': field.section_number.$error }"
              ></b-form-input>
              <div v-if="field.section_number.$error" class="invalid-feedback">
                <span v-if="!field.section_number.required">هذا الحقل الزامي</span>
                <span v-if="!field.section_number.minLength"
                  >يجب أن يتكون رقم القطعة من رقمين على الأقل</span
                >
                <span v-if="!field.section_number.maxLength"
                  >يجب أن يتكون رقم القطعة من 50 رقم على الاكثر</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group
              class="col-md-6 mb-3"
              label="تاريخ الاستلام : "
              label-for="received_date"
            >
              <date-picker
                id="received_date"
                type="date"
                lang="ar"
                value-type="DD-MM-YYYY"
                format="DD-MM-YYYY"
                placeholder="اختر تاريخ الاستلام"
                v-model.trim="field.received_date.$model"
                :class="{ 'is-invalid': field.received_date.$error }"
              ></date-picker>
              <div v-if="field.received_date.$error" class="invalid-feedback">
                <span v-if="!field.received_date.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-6 mb-3"
              label=" المبلغ المستلم : "
              label-for="ammont"
            >
              <b-form-input
                id="ammont"
                type="number"
                placeholder="ادخل المبلغ المستلم"
                v-model.trim="field.ammont.$model"
                :class="{ 'is-invalid': field.ammont.$error }"
              ></b-form-input>
              <div v-if="field.ammont.$error" class="invalid-feedback">
                <span v-if="!field.ammont.required">هذا الحقل الزامي </span>
                <span v-if="!field.ammont.minValue"
                  >يجب أن يكون المبلغ المستلم 1000 على الأقل</span
                >
                <span v-if="!field.ammont.maxValue"
                  >يجب أن يكون المبلغ المستلم 80000000 على الاكثر</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group
              class="col-md-6 mb-3"
              label="نوع الملك : "
              label-for="accommodation_id"
            >
              <select
                class="form-control"
                id="accommodation_id"
                v-model.trim="field.accommodation_id.$model"
                :class="{ 'is-invalid': field.accommodation_id.$error }"
              >
                <option value="">اختر نوع الملك</option>
                <option v-for="accommodation in list_accommodation" :value="accommodation.id" :key="accommodation.id">{{accommodation.name}}</option>
              </select>
              <div v-if="field.accommodation_id.$error" class="invalid-feedback">
                <span v-if="!field.accommodation_id.required">هذا الحقل الزامي </span>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-6 mb-3"
              label=" مساحة القطعة : "
              label-for="area_section"
            >
              <b-form-input
                id="area_section"
                type="number"
                placeholder="ادخل مساحة القطعة"
                v-model.trim="field.area_section.$model"
                :class="{ 'is-invalid': field.area_section.$error }"
              ></b-form-input>
              <div v-if="field.area_section.$error" class="invalid-feedback">
                <span v-if="!field.area_section.required">هذا الحقل الزامي </span>
                <span v-if="!field.area_section.minValue"
                  >يجب أن تكون مساحة القطعة من رقم واحد على الأقل</span
                >
                <span v-if="!field.area_section.maxValue"
                  >يجب أن تكون مساحة القطعة من 4 ارقام على الاكثر</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="col-md-4 mb-3" label="المحافظة : " label-for="city_id">
              <select
                class="form-control"
                id="city_id"
                v-model.trim="field.city_id.$model"
                :class="{ 'is-invalid': field.city_id.$error }"
              >
                <option value="">اختر المحافظة</option>
                <option v-for="city in list_city" :value="city.id" :key="city.id">{{city.name}}</option>
              </select>
              <div v-if="field.city_id.$error" class="invalid-feedback">
                <span v-if="!field.city_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group class="col-md-4 mb-3" label=" القضاء : " label-for="district">
              <b-form-input
                id="district"
                type="text"
                placeholder="ادخل القضاء"
                v-model.trim="field.district.$model"
                :class="{ 'is-invalid': field.district.$error }"
              ></b-form-input>
              <div v-if="field.district.$error" class="invalid-feedback">
                <span v-if="!field.district.required">هذا الحقل الزامي</span>
                <span v-if="!field.district.minLength"
                  >يجب أن تكون القضاء من رقم واحد على الأقل</span
                >
                <span v-if="!field.district.maxLength"
                  >يجب أن تكون القضاء من 4 ارقام على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-4 mb-3" label=" الحي : " label-for="sub_district">
              <b-form-input
                id="sub_district"
                type="text"
                placeholder="ادخل الحي"
                v-model.trim="field.sub_district.$model"
                :class="{ 'is-invalid': field.sub_district.$error }"
              ></b-form-input>
              <div v-if="field.sub_district.$error" class="invalid-feedback">
                <span v-if="!field.sub_district.required">هذا الحقل الزامي</span>
                <span v-if="!field.sub_district.minLength"
                  >يجب أن يكون الحي من حرفين على الأقل</span
                >
                <span v-if="!field.sub_district.maxLength"
                  >يجب أن يكون الحي من 50 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-4">مرفق منحة البناء</h5></div>
            <ul class="li-attachments">
              <li>مرفق يثبت استلام منحة البناء .</li>
              <li>
                يجب ارفاق مستند يثبت استلام منحة البناء ورفعها بملف واحد بصيغة ( pdf. )
                وبحجم لا يتجاوز ( 2mb ) .
              </li>
            </ul>
            <b-form-group
              class="col-md-12 mb-3"
              label=" مرفق منحة البناء :"
              label-for="attachment_grant"
            >
              <div class="custom_file">
                <b-form-file
                  :id="'attachment_grant' + index"
                  class=""
                  :data-index="index"
                  placeholder="اختر المرفق"
                  accept=".pdf"
                  v-model.trim="field.attachment_grant.$model"
                  @change="chnageFile"
                  :class="{ 'is-invalid': field.attachment_grant.$error }"
                ></b-form-file>
                <div v-if="field.attachment_grant.$error" class="invalid-feedback">
                  <span v-if="!field.attachment_grant.required">هذا الحقل الزامي</span>
                  <span v-if="!field.attachment_grant.fileSize"
                    >يجب ان لا يتجاوز حجم الملف 2mb</span
                  >
                  <span v-if="!field.attachment_grant.fileType"
                    >يجب ان يكون نوع الملف pdf</span
                  >
                </div>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-12 mb-3"
              label=" حذف :"
              label-for=""
              v-if="fields.length > 1"
            >
              <div class="d-grid">
                <button
                  type="button"
                  class="btn btn-danger btn-block"
                  @click="deleteRowS(index)"
                >
                  <i class="bx bx-trash font-size-16 align-middle"></i>
                </button>
              </div>
            </b-form-group>
            <div class="col-lg-12"><hr class="mt-0" /></div>
          </div>
          <input
            type="button"
            class="btn btn-primary mt-3 mb-3 mt-lg-0"
            style="width: 100%"
            value="اضافة منحة بناء اخرى"
            @click="AddformDataS"
          />
        </div>
      </form>
    </div>
  </div>

  <!-- end page title -->
</template>
